export default "__VITE_ASSET__EL2R8cN7__"